import { cx } from '@linaria/core';
import { useMemo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { SizeTransition } from '@utils/react';
import { CourseItem } from '../../../../molecules/course-item/_course-item.js';
import { SimplifiedHeader } from '../../../../molecules/course-item/header.simplified.js';
import { courseBuilderStore } from '../../../../state/store.js';
import { courseToKey } from '../../../../utils/course-to-key.js';
import { transitionableRowCls, rowTransitionDurationMs, bodyCls, wrapperCls } from './course-list.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const courseListBodyIdentifier = "course-builder--course-list";
function CourseList(props) {
  const sortedCourses = useMemo(() => props.courses.slice().sort((a, b) => b.modifiedAt.getTime() - a.modifiedAt.getTime()),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.courses.map(courseToKey)]);
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: cx(wrapperCls, props.className),
    children: [/*#__PURE__*/jsx(SimplifiedHeader, {}), /*#__PURE__*/jsx("div", {
      role: "rowgroup",
      className: cx(bodyCls, courseListBodyIdentifier),
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: sortedCourses.map(course => {
          const onCourseClick = () => {
            courseBuilderStore.dispatch(courseBuilderStore.actions.selectCourseById(course.id));
          };
          return /*#__PURE__*/jsx(SizeTransition, {
            axis: "vertical",
            timeout: rowTransitionDurationMs,
            classNames: transitionableRowCls,
            mountOnEnter: true,
            unmountOnExit: true,
            children: ref => /*#__PURE__*/jsx("div", {
              ref: ref,
              className: transitionableRowCls,
              children: /*#__PURE__*/jsx(CourseItem, {
                onCourseClick: onCourseClick,
                item: course,
                simpleLayout: true,
                panelLayout: true
              })
            })
          }, course.__internalId);
        })
      })
    })]
  });
}

export { CourseList };
//# sourceMappingURL=course-list.js.map
